<template>
  <component v-if="currentQuestion && currentComponent" :is="currentComponent"/>
  <placeholder v-else />
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Map from '@/components/stepType/Map.vue';
import Selector from '@/components/stepType/Selector.vue';
import SelectorComRes from '@/components/stepType/SelectorComRes.vue';
import GoalTemperature from '@/components/stepType/GoalTemperature.vue';
import FlowRate from '@/components/stepType/FlowRate.vue';
import FlowRateWithSelect from '@/components/stepType/FlowRateWithSelect.vue';
import HeaterChoice from '@/components/stepType/HeaterChoice.vue';
import Result from '@/components/stepType/Result.vue';
import Placeholder from '@/components/stepType/Placeholder.vue';
import NeedHelp from '@/components/stepType/NeedHelp.vue';
import Call from '@/components/stepType/Call.vue';
import SelectorCabinet from '@/components/stepType/SelectorCabinet.vue';

export default {
  components: {
    Map,
    Selector,
    SelectorComRes,
    GoalTemperature,
    FlowRate,
    FlowRateWithSelect,
    HeaterChoice,
    Result,
    Placeholder,
    NeedHelp,
    Call,
    SelectorCabinet,
  },
  name: 'FlowContainer',
  data() {
    return {};
  },
  mounted() {},
  computed: {
    ...mapState(['selectedFlow', 'flow']),
    ...mapGetters(['currentQuestion']),
    currentComponent() {
      return this.currentQuestion?.component;
    },
  },
  methods: {},
};
</script>

<style lang="scss">

</style>
